// extracted by mini-css-extract-plugin
export default {"overlay":"uh5Hf","overlayInner":"hVv1L","overlayContent":"r93T8","overlayContentDefault":"WHFm5","overlayHeader":"moijF","overlayHeaderTitle":"ZigV8","overlayCloseBtn":"_zM6I"};